import { render, staticRenderFns } from "./comNew.vue?vue&type=template&id=4b1c83ad&scoped=true"
import script from "./comNew.vue?vue&type=script&lang=js"
export * from "./comNew.vue?vue&type=script&lang=js"
import style0 from "./comNew.vue?vue&type=style&index=0&id=4b1c83ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1c83ad",
  null
  
)

export default component.exports